export const FRAGNO1_RESOLVED = 'FRAGNO1_RESOLVED';

export const fragno1Resolved = ({ on, source }) => ({
  payload: { on, source },
  type: FRAGNO1_RESOLVED,
});
